import ResultsTableRow from "./ResultsTableRow";

const ResultsTable = ({ results = [] }) => {
  if (!results.length) {
    return null;
  }
  return (
    <div className="card color-white">
      <div className="card__header">
        <h2 className="card__label">Results</h2>
      </div>
      <div className="card__body">
        <div className="table-wrapper table--embedded">
          <table className="table">
            <thead className="thead">
              <tr className="tr">
                <th className="th">Copilot ID</th>
                <th className="th">Status</th>
                <th className="th">Share URL</th>
              </tr>
            </thead>
            <tbody className="tbody">
              {results.map((row, i) => <ResultsTableRow row={row} key={i} />)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};

export default ResultsTable;